import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { FC, useCallback } from "react";
import { Helmet } from "react-helmet";
import { RouteComponentProps } from "react-router";
import Button from "../../../components/Button";
import Error from "../../../components/Error";
import Info from "../../../components/Info";
import Loading from "../../../components/Loading";
import WeduTooltip from "../../../components/WeduTooltip/intex";
import { endOfTitle } from "../../../constants/constants";
import { useWizard } from "../../wizard/context";
import { useServicesPage } from "../hooks/useServicesPage";
import ServiceListItem from "../components/ServiceListItem";
import { Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
  },
  buttonContainer: {
    marginBottom: theme.spacing(3),
    padding: 0,
    textAlign: "right",
  },
  button: {
    maxWidth: 280,
    fontSize: 16,
  },
  info: {
    height: 400,
  },
}));

const ServicesPage: FC<RouteComponentProps> = () => {
  const classes = useStyles();

  const { openWizard } = useWizard();
  const {
    isLoading,
    isError,
    errorMessage,
    services,
    servicesWizardConfigs,
    refetchServices,
  } = useServicesPage();

  const addCourse = useCallback(async () => {
    (await openWizard(servicesWizardConfigs.getCreateConfig())) &&
      (await refetchServices());
  }, []);

  return (
    <>
      <Helmet>
        <title>Services{endOfTitle}</title>
      </Helmet>
      {isLoading && <Loading />}
      <Container maxWidth={"lg"}>
        <Grid item xs={12}>
          {!isLoading && (
            <>
              <Container maxWidth="lg" className={classes.buttonContainer}>
                <WeduTooltip title="Add service">
                  <Button
                    color={"success"}
                    variant={"contained"}
                    onClick={addCourse}
                    className={classes.button}
                  >
                    Add
                  </Button>
                </WeduTooltip>
              </Container>
              {isError ? (
                <Error text={errorMessage} />
              ) : services && services.length > 0 ? (
                <Container maxWidth="lg" className={classes.container}>
                  <Grid container spacing={2}>
                    {services?.map((service) => (
                      <ServiceListItem key={service.id} service={service} />
                    ))}
                  </Grid>
                </Container>
              ) : (
                <Container maxWidth="lg" className={classes.container}>
                  <Info
                    className={classes.info}
                    text={
                      "There is no services created.\nPlease create services."
                    }
                  />
                </Container>
              )}
            </>
          )}
        </Grid>
      </Container>
    </>
  );
};

export default ServicesPage;
